import bgImage from '../../assets/RideLoginBackground.png';

const styles = theme => ({
  root: {
  	width: '100%',
  	height: '100%',
  	background: `URL('${bgImage}') no-repeat fixed`,
  	backgroundSize: 'cover',
  },
  main: {
    width: '300px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '150px',
    padding: '30px',
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    width: '100%',
    backgroundColor: theme.palette.primary.contrastText,
    color: theme.palette.primary.main,
    height: 35,
    paddingLeft: 0,
    '& input': {
      paddingLeft: 10
    }
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
  button: {
    margin: theme.spacing(1),
  },
  labelTitle: {
    margin: 0,
    fontWeight: '700',
    fontSize: '18px',
    color: theme.palette.secondary.main,
    textAlign: 'center'
  },
  labelCaption: {
    margin: 0,
    fontWeight: '700',
    fontSize: '14px',
    color: theme.palette.primary.contrastText
  },
  validationLabel: {
    color: theme.palette.secondary.light,
    paddingLeft: '8px',
  },
  logo: {
    width: '80%'
  },
  h2: {
    padding: 0,
    textAlign: 'center'
  },
  actions: {
  	width: '100%',
  	textAlign: 'center'
  }
});

export default styles;
